import React, { useEffect, useState } from "react";
import { GrFormClose } from "react-icons/gr";
import Modal from "../../../components/Modal";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import { Bar } from "react-chartjs-2";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
function generateRandomHexCode() {
  let hexCode = "#";
  const hexChars = "0123456789ABCDEF";
  for (let i = 0; i < 6; i++) {
    hexCode += hexChars[Math.floor(Math.random() * 16)];
  }
  return hexCode;
}
const CompareModal = ({ onClose, selectedSurveys }) => {
  const [reArrangedData, setReArrangedData] = useState([]);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top"
      },
      title: {
        display: true,
        text: "compare chart"
      }
    }
  };

  const reArrangeDataHandler = () => {
    const keys = Object.keys(selectedSurveys[0]);
    let tempData = [];
    keys.forEach((key) => {
      let value = 0;
      selectedSurveys.forEach((survey) => {
        value += Number(survey[key]);
      });
      tempData.push(value / selectedSurveys.length);
    });
    setReArrangedData(tempData);
  };

  const labels = Object.keys(selectedSurveys[0]);

  const data = {
    labels,
    // datasets: selectedSurveys.map((item, idx) => ({
    //   label: "Survey " + (idx + 1),
    //   data: labels.map((l) => item[l]),
    //   backgroundColor: generateRandomHexCode()
    // }))
    datasets: [
      {
        label: "Survey",
        data: reArrangedData,
        backgroundColor: generateRandomHexCode()
      }
    ]
  };
useEffect(()=>{
  reArrangeDataHandler()
},[])
  return (
    <Modal>
      <div className="">
        <div className="">
          <div className="flex items-center justify-between">
            <p className="font-bold text-lg text-black"></p>
            <GrFormClose
              size={18}
              onClick={onClose}
              className="text-gray-800 cursor-pointer"
            />
          </div>
          <div className="w-[500px] h-[300px]">
            <Bar options={options} data={data} />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CompareModal;
